import { apiFetch } from '@/shared/api/apiFetch';
import { orgUnitsTreeResponseSchema, type OrgUnitsTreeResponse } from '../model/organizationSchema';

export type OrgUnitsTreeParams = {
  root_id?: string;
  q?: string;
};

/** GET /v1/org-units/tree — дерево оргструктуры (depth=1, lazy-load). */
export async function fetchOrgUnitsTree(params: OrgUnitsTreeParams = {}): Promise<OrgUnitsTreeResponse> {
  const sp = new URLSearchParams();
  if (params.root_id) sp.set('root_id', params.root_id);
  if (params.q) sp.set('q', params.q);
  const qs = sp.toString();
  const json = await apiFetch<unknown>(`/org-units/tree${qs ? `?${qs}` : ''}`, { method: 'GET' });
  return orgUnitsTreeResponseSchema.parse(json);
}
